import React from "react";

const PmMatrixCell = ({ cellData, task, plan, onClick }) => {
  const { state, executionDate, notes, technicianId, month, year } = cellData;

  const getStatusIcon = (state) => {
    switch (state) {
      case "Completed":
        return (
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ width: "14px", height: "14px" }}
          >
            <path d="M20 6L9 17l-5-5" />
          </svg>
        );
      case "Scheduled":
        return (
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "currentColor",
            }}
          />
        );
      case "Overdue":
        return (
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ width: "14px", height: "14px" }}
          >
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        );
      default:
        return null;
    }
  };

  const getTooltip = () => {
    if (state === "Blank") {
      return "Not Scheduled\nClick to schedule";
    }

    const lines = [];
    const statusLabel =
      state === "Completed"
        ? "Status: Completed"
        : state === "Overdue"
          ? "Status: Overdue"
          : "Status: Scheduled";
    lines.push(statusLabel);

    if (state === "Completed") {
      const person =
        task?.responsible && task.responsible !== "Not Assigned"
          ? task.responsible
          : "Technician";
      lines.push(`Completed By: ${person}`);
    } else if (state === "Scheduled" || state === "Overdue") {
      const person =
        task?.responsible && task.responsible !== "Not Assigned"
          ? task.responsible
          : "Not Assigned";
      lines.push(`Assigned To: ${person}`);
    }

    const dateLabel = state === "Completed" ? "Completion Date" : "Due Date";
    const dateStr = executionDate
      ? new Date(executionDate).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
      : month && year
        ? `${month} ${year}`
        : "N/A";

    lines.push(`${dateLabel}: ${dateStr}`);

    if (notes) {
      lines.push(`Notes: ${notes}`);
    }

    return lines.join("\n");
  };

  return (
    <div
      className={`matrix-cell cell-state-${state}`}
      onClick={onClick}
      title={getTooltip()}
    >
      <span
        className="cell-icon"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {getStatusIcon(state)}
      </span>
    </div>
  );
};

export default PmMatrixCell;
